import React from 'react'
import styled from 'styled-components'
import { useExploreContext } from '../../contexts/ExploreContext'

const FilterButton = styled.button`
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 48px;
  height: 48px;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  box-shadow: 0 1px 4px ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 10;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    bottom: 16px;
    left: 8px;
  }
`

const FilterIcon = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
`

// const FilterCount = styled.span`
//   position: absolute;
//   top: -10px;
//   right: -10px;
//   background: #00ade6;
//   color: white;
//   font-size: 10px;
//   font-weight: 600;
//   min-width: 18px;
//   height: 18px;
//   border-radius: 9px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 0 4px;
// `

interface FilterControlProps {
  loaded?: boolean
  map?: any
}

export const FilterControl: React.FC<FilterControlProps> = () => {
  const { filterPanelOpen, setFilterPanelOpen } = useExploreContext()

  return (
    <FilterButton
      onClick={() => setFilterPanelOpen(!filterPanelOpen)}
      title={filterPanelOpen ? 'Close filters' : 'Open filters'}
    >
      <FilterIcon>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
        {/* {activeFilters > 0 && <FilterCount>{activeFilters}</FilterCount>} */}
      </FilterIcon>
    </FilterButton>
  )
}
